module.exports = __webpack_public_path__ + "static/media/girl-ills.85cd2706.svg";